import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';

import './styles.css';

interface IProps {
  pages: any;
  qtdLoading: any;
  theme: any;
  customClass?: any;
}

class BreadCrumb extends PureComponent<IProps> {
  render() {
    return (
      // <div className={`breadcrumb-root ${this.props.qtdLoading && !this.props.theme ? 'loading' : null}`}>
      <div className={this.props.customClass ? `breadcrumb-root ${this.props.customClass} ` : 'breadcrumb-root'}>
        <div className='breads'>
          {this.props.pages.map((page: any, index: any) => (
            <div key={index} className='bread'>
              {page?.icon && <Icon className='bread-icon'>{page.icon}</Icon>}
              <Link to={page.link}>{page.name}</Link>
              {index < this.props.pages.length - 1 && <label>/</label>}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  qtdLoading: state.loading.qtdRequestLoading,
  theme: state.template.theme,
});

export default connect(mapStateToProps)(BreadCrumb);
